import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

let state = {
  popupType: null,
  popupResolve: null,
  popupReject: null,
  popupData: null,
  notification: { message: '' },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
